<template>
  <div id="app">
    <div>
      <!-- 上方工具栏 -->
      <div id="topTool" class="mdui-toolbar mdui-container-fluid">
        <a @click="aboutVisable=true" class="mdui-btn mdui-btn-icon mdui-ripple">
          <i class="mdui-icon material-icons">&#xe24e;</i>
        </a>
        <span class="mdui-typo-title mdui-ripple">To Do List</span>
        <div class="mdui-toolbar-spacer"></div>
        <a class="mdui-btn mdui-btn-icon mdui-ripple" @click="formVisable = true">
          <i class="mdui-icon material-icons">&#xe145;</i>
        </a>
      </div>

      <!-- 添加事项对话框 -->
      <el-dialog title="新增事项" :visible.sync="formVisable" width="90%" top="160px">
        <el-form :model="form">
          <el-input v-model="form.name" maxlength="9"></el-input>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="add" plain>OK</el-button>
        </div>
      </el-dialog>

      <!-- 关于对话框 -->
      <el-dialog closed="load" title="About" :visible.sync="aboutVisable" width="70%" top="160px">
        <p>To Do List v 0.1.0</p>
        <br />
        <p>Designed by Viki</p>
        <p>Last updated: 2020-1-11 23:00</p>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" plain @click="aboutVisable=false">OK</el-button>
        </div>
      </el-dialog>
    </div>

    <div class="index">
      <el-card class="box-card" id="todo">
        <div slot="header" class="clearfix">
          <span>待办事项</span>
        </div>
        <el-row>
          <div v-for="(i,n) in list.todo" :key="i" class="text item">
            <el-col :span="18">
              <div class="grid-content">
                <el-tag type="warning" size="big">{{n+1}}</el-tag>
                {{i}}
              </div>
            </el-col>
            <el-col :span="6" push:1>
              <div class="grid-content">
                <el-button
                  @click="change(n,1)"
                  type="success"
                  icon="el-icon-check"
                  size="mini"
                  plain
                  circle
                ></el-button>
                <el-button
                  type="danger"
                  size="mini"
                  icon="el-icon-delete"
                  @click="dele(n,1)"
                  plain
                  circle
                ></el-button>
              </div>
            </el-col>
          </div>
        </el-row>
      </el-card>
      <el-card class="box-card" id="done">
        <div slot="header" class="clearfix">
          <span>已完成</span>
        </div>
        <el-row>
          <div v-for="(i,n) in list.done" :key="i" class="text item">
            <el-col :span="18">
              <div class="grid-content">
                <el-tag type="success" size="big">{{n+1}}</el-tag>
                {{i}}
              </div>
            </el-col>
            <el-col :span="6" push:1>
              <div class="grid-content">
                <el-button
                  @click="change(n,2)"
                  type="warning"
                  icon="el-icon-refresh-left"
                  size="mini"
                  plain
                  circle
                ></el-button>
                <el-button
                  type="danger"
                  size="mini"
                  icon="el-icon-delete"
                  @click="dele(n,2)"
                  plain
                  circle
                ></el-button>
              </div>
            </el-col>
          </div>
        </el-row>
      </el-card>
    </div>
  </div>
</template>

<script>
export default {
  name: "app",
  data() {
    return {
      list: {
        todo: [],
        done: []
      },
      formVisable: false,
      aboutVisable: false,
      form: {
        name: "",
        status: ""
      },
      formLabelWidth: "60px"
    };
  },
  methods: {
    add() {
      if (this.form.name == "") {
        this.msg("名称不能为空", "w");
      } else {
        this.list.todo.push(this.form.name);
        localStorage.setItem("list", JSON.stringify(this.list));
        this.formVisable = false;
        location.reload();
      }
    },
    dele(n, x) {
      if (x == 1) {
        this.list.todo.splice(n, 1);
      } else {
        this.list.done.splice(n, 1);
      }
      this.msg("删除成功", "e");
      localStorage.setItem("list", JSON.stringify(this.list));
      if (this.list.todo.length == 0 && this.list.done.length == 0) {
        localStorage.removeItem("list", JSON.stringify(this.list));
        this.msg("已清空", "s");
      }
    },
    load() {
      if (localStorage.getItem("list")) {
        this.list = JSON.parse(localStorage.getItem("list"));
        this.msg("本地事项加载成功", "s");
      } else {
        this.msg("本地没有任何事项记录", "w");
      }
    },
    change(n, x) {
      if (x == 1) {
        let a = this.list.todo[n];
        this.list.todo.splice(n, 1);
        this.list.done.unshift(a);
        this.msg("标记为已完成", "s");
      } else {
        let a = this.list.done[n];
        this.list.done.splice(n, 1);
        this.list.todo.unshift(a);
        this.msg("标记为代办事项", "w");
      }
      localStorage.setItem("list", JSON.stringify(this.list));
    },
    msg(str, type) {
      var TYPE = "info";
      switch (type) {
        case "s":
          TYPE = "success";
          break;
        case "w":
          TYPE = "warning";
          break;
        case "i":
          TYPE = "info";
          break;
        case "e":
          TYPE = "error";
          break;
      }
      this.$message({
        message: str,
        type: TYPE,
        center: true,
        offset: -1,
        duration: 1000
      });
    }
  },
  mounted() {
    this.load();
  }
};
</script>

<style lang="scss" scoped>
$todoColor: rgb(240, 183, 97);
$doneColor: rgb(103, 194, 58);
$infoColor: rgb(64, 158, 255);

#topTool {
  box-shadow: 0px 0px 4px 2px rgb(185, 185, 185);
}
#todo {
  color: $todoColor;
}
#done {
  color: $doneColor;
}
.text {
  font-size: 18px;
  line-height: 36px !important;
}
span {
  font-size: 20px;
  font-weight: bold;
  color: black;
}
.item {
  margin: 6px;
}

.box-card {
  margin: 16px;
}
</style>
